import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-button-edit',
  templateUrl: './st-button-edit.component.html',
  styleUrls: ['./st-button-edit.component.scss'],
  standalone: false
})
export class StButtonEditComponent {

  @Input()
  idVal: string = 'buttonId';

  @Input()
  label = 'Edit';

  @Output()
  onClick = new EventEmitter<Event>();
}
